import { Fragment } from 'react';

import useMeetSearch from './UseMeetSearch';

import SearchMeet from '@usas/ui-web/components/searches/searchMeet/SearchMeet';

const MeetSearchWrite = () => {
  const simplifiedView = false;
  const { searchMeetState, onEditMeet, onAddMeet } = useMeetSearch(simplifiedView);

  return (
    <Fragment>
      <SearchMeet
        pageTitle={"Meet Search"}
        searchButtonText={"Search for Meet"}
        onEdit={onEditMeet}
        onAdd={onAddMeet}
        searchMeetState={searchMeetState}
        simplifiedView={simplifiedView}
      />
    </Fragment>
  );
}

export default MeetSearchWrite;